/** Checks whether the `embeddedMobile` cookie is present, set by the native mobile apps for embedded webviews */
export default function isEmbeddedMobile(): boolean {
  try {
    return document.cookie.split(';').some((item) => item.trim().startsWith('embeddedMobile='))
  } catch (error) {
    return false
  }
}
